import React from "react";

const ComingSoonIcon = () => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M153.033 45.3098L182.37 16.2532C183.616 15.0196 185.676 15.2223 186.657 16.6751L193.425 26.6942C194.357 28.0743 193.884 29.9579 192.411 30.7348L156.307 49.7723C155.697 50.094 154.99 50.1792 154.322 50.0115C153.653 49.8438 153.07 49.4351 152.684 48.8637C152.319 48.3236 152.154 47.6727 152.218 47.0238C152.281 46.3749 152.57 45.7686 153.033 45.3098ZM157.885 70.2626C157.995 70.8 158.299 71.278 158.74 71.6046C159.181 71.9313 159.727 72.0837 160.273 72.0325L192.609 69.0137C192.921 68.9846 193.223 68.8902 193.495 68.7367C193.767 68.5832 194.004 68.374 194.191 68.1228C194.377 67.8716 194.508 67.5839 194.576 67.2786C194.643 66.9733 194.646 66.6572 194.583 66.3509L192.654 56.9255C192.374 55.5591 190.921 54.7833 189.63 55.3118L159.223 67.7555C158.743 67.9521 158.346 68.3102 158.102 68.7679C157.858 69.2256 157.781 69.7543 157.885 70.2626ZM133.741 35.9485C134.199 36.2506 134.752 36.3731 135.294 36.2925C135.837 36.2119 136.33 35.9339 136.681 35.5118L157.411 10.5118C157.611 10.271 157.758 9.99092 157.842 9.68972C157.926 9.38851 157.946 9.07297 157.9 8.76363C157.854 8.45429 157.743 8.15811 157.575 7.89436C157.407 7.63062 157.185 7.40523 156.924 7.23289L148.896 1.9325C147.732 1.16414 146.156 1.64304 145.617 2.92976L132.914 33.2302C132.714 33.7086 132.687 34.242 132.838 34.7383C132.988 35.2346 133.308 35.6626 133.741 35.9485Z"
        fill="#92C7FF"
      />
      <path
        d="M85.3126 187.436L79.0673 191.088C73.9908 194.057 67.4689 192.349 64.5001 187.272L47.9415 158.957C44.9728 153.88 46.6814 147.358 51.7579 144.39L58.0033 140.737C63.0798 137.768 69.6017 139.477 72.5704 144.554L89.129 172.869C92.0982 177.945 90.3892 184.467 85.3126 187.436Z"
        fill="#E40891"
      />
      <path
        d="M47.0324 159.649L107.544 126.704L66.1781 61.9348L11.4785 102.573C11.1257 102.798 -3.65865 116.325 12.5777 141.748C28.814 167.17 47.0324 159.649 47.0324 159.649Z"
        fill="#1D1E9D"
      />
      <path
        d="M141.614 59.4648C159.713 87.8038 170.679 118.505 163.107 123.341C155.535 128.177 132.292 105.317 114.193 76.9777C96.0931 48.6382 85.1279 17.9382 92.6998 13.1019C100.272 8.26557 123.514 31.1253 141.614 59.4648Z"
        fill="#ECF2FE"
      />
      <path
        d="M133.091 98.7886C139.364 94.782 137.567 80.7585 129.077 67.4662C120.587 54.1739 108.619 46.6464 102.346 50.6531C96.0735 54.6597 97.8708 68.6832 106.361 81.9755C114.851 95.2678 126.818 102.795 133.091 98.7886Z"
        fill="#92C7FF"
      />
      <path
        d="M162.776 123.552C156.162 127.776 133.697 104.421 115.597 76.0812C97.4973 47.7417 85.7551 17.5374 92.3692 13.3132C92.75 13.0698 93.1774 12.9093 93.6442 12.8206C90.5239 12.7491 87.4668 14.3765 85.6578 17.8358C77.686 33.0812 57.341 66.9054 57.341 66.9054C57.341 66.9054 47.2453 80.4991 64.9926 108.286C82.7399 136.073 99.8739 132.596 99.8739 132.596C99.8739 132.596 138.797 128.62 155.899 127.803C159.948 127.61 162.768 125.362 163.939 122.329C163.628 122.841 163.243 123.253 162.776 123.552Z"
        fill="#ECF2FE"
      />
      <path
        d="M20.6608 120.38C19.7358 120.382 18.8254 120.15 18.014 119.705C17.2026 119.261 16.5164 118.619 16.019 117.839C14.3835 115.279 15.1335 111.877 17.6944 110.241L40.3159 95.7938C42.8765 94.1586 46.2784 94.9082 47.914 97.4692C49.5495 100.03 48.7995 103.432 46.2386 105.067L23.6171 119.515C22.735 120.081 21.7088 120.381 20.6608 120.38Z"
        fill="#ACADFF"
      />
    </svg>
  );
};

export default ComingSoonIcon;
